import { useTranslation } from 'react-i18next'

import cross from 'assets/cross-in-circle.svg'
import avatarPlaceholder from 'assets/avatar-placeholder.svg'
import pen from 'assets/pen.svg'
import qr from 'assets/qr.svg'
import Icon from 'features/common/components/Icon/Icon'
import { Employee } from '../../../../../common/core/entities/employee'

type EmployeeCardProps = {
    employee: Employee
    onEdit: (p: Employee) => void
    onOpenQR: (p: Employee) => void
    onDelete: (p: Employee) => void
}

const EmployeeCard = ({
    employee,
    onEdit,
    onOpenQR,
    onDelete,
}: EmployeeCardProps) => {
    const { t } = useTranslation()

    const { avatar, firstName, lastName, phone, email, role } = employee
    return (
        <div className="grid grid-cols-3 divide-x rounded-lg border-l-[6px] border-[#FF7262] bg-white p-2.5 shadow-x">
            <div className="col-span-1 flex gap-6">
                <img
                    className="h-20 w-20 rounded-full"
                    src={avatar || avatarPlaceholder}
                    alt="avatar"
                />
                <div className="flex min-w-0 flex-col justify-center gap-2">
                    <div className="min-w-0 overflow-hidden text-ellipsis text-xl font-bold">
                        {firstName} {lastName}
                    </div>
                    <div className="min-w-0 overflow-hidden text-ellipsis text-grey-10">
                        {role}
                    </div>
                </div>
            </div>
            <div className="col-span-1 flex flex-col justify-center gap-3 px-6 text-sm">
                <div>
                    <span>{t('QR_EMPLOYEE_PHONE')}</span>{' '}
                    <span className="text-grey-10">{phone}</span>
                </div>
                <div>
                    <span>{t('QR_EMPLOYEE_EMAIL')}</span>{' '}
                    <span className="text-grey-10">{email}</span>
                </div>
            </div>
            <div className="col-span-1 flex items-center justify-center gap-6">
                <Icon onClick={() => onOpenQR(employee)} src={qr} alt="qr" />
                <Icon onClick={() => onEdit(employee)} src={pen} alt="edit" />
                <Icon
                    onClick={() => onDelete(employee)}
                    src={cross}
                    alt="delete"
                />
            </div>
        </div>
    )
}

export default EmployeeCard
